import { ToggleButton, Tooltip, type ToggleButtonProps } from '@mui/material';

import Icon from 'app/main/components/Icon';

type EditorHtmlToolbarButtonProps = {
	/** Button icon */
	icon: string;
	/** Button icon color */
	iconColor?: string;
	/** Button secondary icon */
	secondaryIcon?: string;
	/** Button tooltip */
	tooltip: string;
} & Pick<
	ToggleButtonProps,
	'className' | 'size' | 'color' | 'value' | 'disabled' | 'selected' | 'onPointerEnter' | 'onChange' | 'onClick'
>;

/** Html editor toolbar toggle button */
export default function EditorHtmlToolbarButton({
	className,
	size,
	color,
	icon,
	iconColor,
	secondaryIcon,
	tooltip,
	value,
	disabled,
	selected,
	onPointerEnter,
	onChange,
	onClick
}: EditorHtmlToolbarButtonProps) {
	return (
		<Tooltip title={tooltip} placement="top" arrow>
			<ToggleButton
				className={className}
				size={size}
				color={color}
				value={value}
				component={disabled ? 'div' : 'button'}
				disabled={disabled}
				selected={selected}
				onPointerEnter={onPointerEnter}
				onChange={onChange}
				onClick={onClick}
			>
				<Icon icon={icon} size={20} color={iconColor} />
				{secondaryIcon && <Icon icon={secondaryIcon} size={20} />}
			</ToggleButton>
		</Tooltip>
	);
}
